export interface FacilityRoleDto {
  id: number;
  facilityId: string; // Guid
  name: string;
  description?: string | null;
  isProtected: boolean;
  isActive: boolean;
  permissionTypeIds: number[];
  permissionNames: string[];
  createdAt: string; // DateTime as ISO string
  updatedAt: string; // DateTime as ISO string
}
